import React from 'react'
import OnboardingContainer from './OnboardingContainer'
import GstPanInput from './Components/GstPanInput'
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

const OnboardFirm = () => {
  const navigate = useNavigate();
  const manufacturerRoleFlow = useSelector(state => state.FirmOnboardingReducer.manufacturerRoleFlow);
  
  return (
    <OnboardingContainer title="Business Info" ShowIcon={true}
      navigation={() => navigate(-1)}
      buttonHandler={() => navigate('/')}
    >
        <GstPanInput/>
    </OnboardingContainer>
  )
}

export default OnboardFirm